import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../../hooks/useQuriesSuccess';
import Global from '../../../../../Services/Common/Global';
import useDeleteMutation from '../../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../../util';
import { TRA_NEW_05_Schema } from './TRA_NEW_05_Schema';
import useSearchMutaion from '../../../../../hooks/apis/useSearchMutaion';
import { apiRequest } from '../../../../../Services/Common/ApiRequest';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(TRA_NEW_05_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Training', 'getTraNew05R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraNew05R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(TRA_NEW_05_Schema.mapper.search2, context);

    return apiRequest('post', Global.urls.Training.getTraNew05R2, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_NEW_05_Schema.mapper.save1);

    return apiRequest('post1', Global.urls.Training.saveTraNew05U1, payload);
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_NEW_05_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Training.deleteTraNew05D1, payload);
  }, options);
};
